import { render, staticRenderFns } from "./ProjectsBreadcrumbs.vue?vue&type=template&id=2a5a07c7&scoped=true&"
import script from "./ProjectsBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ProjectsBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsBreadcrumbs.vue?vue&type=style&index=0&id=2a5a07c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a07c7",
  null
  
)

export default component.exports